{
    "CRMConfiguration_Table_Headers_Description": "Beschreibung",
    "CRMConfiguration_Table_Headers_Type": "Typ",
    "CRMConfiguration_Table_Headers_TelSys": "Telefonieserver",
    "CRMConfiguration_Table_Headers_Partition": "Partition",
    "CRMConfiguration_Table_Headers_Device": "Gerät",
    "NAME": "CRMConfigurationLanguage"
}